export default {
  default: {
    title: 'No Calendars Available',
    paragraph:
      'There are no calendars available in this project yet. If you’re integrated with a marketing platform that exports calendars you can import them here, or you can create one from scratch.',
  },
}
